import React from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import BaseWholesaleController from "./BaseWholesaleController";
import NtRootPageContainer from "../../root/components/NtRootPageContainer";
import Logger from "../../common/utils/Logger";

class WholesaleController extends BaseWholesaleController {
  state = {};

  componentDidMount() {
    this.didFocusListener = this.props.navigation.addListener(
      "focus",
      this.handleFocus
    );
  }

  componentDidUpdate(prevProps) {
    // Check if the params have changed

    if (prevProps.route.params !== this.props.route.params) {
    }
  }

  componentWillUnmount() {
    // Remove the event listener
    this.didFocusListener();
  }

  handleFocus = () => {
    Logger("Wholesale Controller focused params:", this.props.route);
  };
  render() {
    return (
      <NtRootPageContainer
        style={styles.container}
        pageTitle={"Wholesale"}
      ></NtRootPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
});

export default WholesaleController;
